import StatusChip from "@components/ui-components/status-chip";
import InvoiceActionCell from "../components/invoice-action-cell";
import { formatCurrency } from "@src/utility/helpers/utils";
import { formatDate } from "@src/utility/helpers/date";
import { PAYOUT_TONE, PAYOUT_LABEL } from "@src/utility/constants/panel/common";

// Built per render rather than declared flat: the action column needs the
// currently uploading row and the picker handler from the upload hook.
export const getEarningsColumns = ({ currency, uploadingRowId, onUpload }) => [
    {
        Header  : "Period",
        accessor: "period",
        sortable: true,
        Cell    : ({ value }) => <span className="text-gray-700">{value}</span>
    },
    {
        Header  : "Brand",
        accessor: "brand_name",
        sortable: true,
        Cell    : ({ value }) => <span className="text-gray-700">{value}</span>
    },
    {
        Header  : "Invoice",
        accessor: "invoice_ref",
        Cell    : ({ value }) => <span className="font-mono text-xs text-muted">{value}</span>
    },
    {
        Header  : "Amount",
        accessor: "amount",
        sortable: true,
        Cell    : ({ value }) => <span className="text-gray-900">{formatCurrency(value, currency)}</span>
    },
    {
        Header  : "Status",
        accessor: "status",
        Cell    : ({ value }) => <StatusChip tone={PAYOUT_TONE[value] || "neutral"} label={PAYOUT_LABEL[value] || value} />
    },
    {
        Header  : "Confirmation",
        accessor: "confirmation_id",
        Cell    : ({ value, row }) => (
            <span className="text-xs text-muted">{value ? `${value} · ${formatDate(row.confirmation_date)}` : "—"}</span>
        )
    },
    {
        Header  : "Action",
        accessor: "id",
        Cell    : ({ row }) => (
            <InvoiceActionCell
                row={row}
                uploading={uploadingRowId === row.id}
                onUpload={onUpload} />
        )
    }
];
